const industries = [
  "Author/BookPage",
  "Speaker",
  "Coach",
  "Consultant",
  "GYM/Fitness",
  "Professional Services",
  "Retail",
  "Ecommerce",
  "B2B",
  "Network Marketing",
  "Travel",
  "Hotel",
  "Restaurants",
  "Real Estate",
  "Book Publishing ",
  "Freelancer",
  "Others"
];

export default industries;
